export const AGENCY_SCOPE = [
  'Integraciones API y webhooks.',
  'Automatizaciones de procesos.',
  'Paneles internos y miniaplicaciones.',
  'Formularios conectados con CRM o email.',
  'Funcionalidades web que requieren desarrollo.',
  'Despliegues y backends ligeros con Cloudflare.',
] as const;
